import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { showEmailVerificationFlowModal } from '../../actions/modals'

// Auto-opens the centered verify-primary / add-backup modal (same pattern as
// the rest of the app's modals, e.g. Update Email) once per app session,
// as soon as the server says a prompt is due and no other modal is in the way.
// Once — not once per variant — so closing it (e.g. "Not now" on a backup
// step reached from affirmBoth, or "Remind me later" on verifyPrimary while
// addBackup is also due) doesn't immediately pop a different variant back
// up; anything that should follow on is chained inside the modal itself.
// Only opens while on the library — a low-stakes browsing page — so it never
// pops up mid-task (editing, Live View, scanning, etc.) in long sessions.
function EmailVerificationBannerContainer(props) {
  const {
    prompts, currentModal, hasBackupEmail, showEmailVerificationFlowModal, location,
  } = props
  const onLibrary = location.pathname.startsWith('/library')
  const shownRef = useRef(false)

  useEffect(() => {
    if (shownRef.current) return
    if (!onLibrary) return
    if (currentModal) return // don't interrupt whatever modal is already open

    // priority: a full primary re-verify beats everything (it needs a code).
    // Whenever either affirm is due and there's a backup email to show, always
    // use the combined "are these still yours?" screen, which affirms both
    // addresses in one go — even if only one of the two is actually due.
    // Without a backup email, affirmBackup can't be due (nothing to affirm),
    // so a stale primary gets its own screen, which can then chain into the
    // add-backup ask.
    const affirmDue = prompts.affirmPrimary || prompts.affirmBackup
    let variant = null
    let initialStep = null
    if (prompts.verifyPrimary) {
      variant = 'verifyPrimary'
      initialStep = 'verifyPrimaryOffer'
    } else if (affirmDue && hasBackupEmail) {
      variant = 'affirmBoth'
      initialStep = 'affirmBothOffer'
    } else if (prompts.affirmPrimary) {
      variant = 'affirmPrimary'
      initialStep = 'affirmPrimaryOffer'
    } else if (prompts.addBackup) {
      variant = 'addBackup'
      initialStep = 'backupOffer'
    }
    if (!variant) return

    shownRef.current = true
    showEmailVerificationFlowModal(variant, initialStep)
  }, [prompts.verifyPrimary, prompts.affirmPrimary, prompts.addBackup, prompts.affirmBackup,
    hasBackupEmail, currentModal, onLibrary])

  return null
}

export default withRouter(connect(
  (state) => ({
    prompts: state.emailVerification.prompts,
    hasBackupEmail: !!state.user.backupEmail,
    currentModal: state.modals.currentModal,
  }),
  { showEmailVerificationFlowModal },
)(EmailVerificationBannerContainer))
